<template>
  <el-dialog
    :title="$t('SeaExport.PreviewOfBookingFileParsing') + (orderNo ? ' - ' + orderNo : '')"
    custom-class="intelligent-booking-result-dialog"
    :visible.sync="innerVisible"
    fullscreen
    :modal="false"
    :append-to-body="true"
    :destroy-on-close="true"
  >
    <cargo-left-right-resize
      style="width:100%;height: 100%;"
      :left-style="{'min-width': '405',width:'46%'}"
      :right-style="{'min-width': '550px',width:'60%'}"
    >
      <template slot="left">
        <div style="width: 100%;height:100%;overflow: auto;">
          <image-preview-xhq v-if="visible" :image-info="resultJson" :cur-focus="curFocus" /></div>
      </template>
      <template slot="right">
        <div style="width: 100%;height:100%;overflow: auto;">
          <result-form-xhq v-if="visible" ref="resultForm" :details="details" @fieldFocus="(val)=>curFocus=val" />
        </div>
      </template>
    </cargo-left-right-resize>
    <div v-if="details.status === 3" slot="footer" style="text-align: center">
      <el-button no="1" @click="handleClose">{{ $t('Message.Close') }}</el-button>
    </div>
    <div v-else slot="footer" style="text-align: center">
      <el-button no="2" type="success" @click="handleSave">{{ $t('Payment.save') }}</el-button>
      <el-button no="3" type="primary" @click="handleCreateOrder">{{ $t('SeaExport.GenerateOrder') }}</el-button>
      <el-button no="4" @click="handleClose">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import ImagePreview from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/ImagePreview'
import ResultForm from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/ResultForm'
import { saveResultJsonXhq } from '@/api/seaExport/intelligentBooking'
import { getLoading } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'
import DateUtils from '@/utils/dateUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import ResultFormXhq from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/ResultFormXhq'
import ImagePreviewXhq from '@/views/cargo/v0/SeaExport/IntelligentBooking/components/ImagePreviewXhq'
import { deepClone } from '@/utils'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import { Company } from '@/class/model/mdm/Company'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { Customer } from '@/class/model/mdm/Customer'

export default {
  name: 'IntelligentBookingResultXhq',
  components: { ImagePreviewXhq, ResultFormXhq, ResultForm, ImagePreview, CargoLeftRightResize },
  props: {
    details: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: () => false
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    },
    jingyuWarehouse: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      curFocus: ''
    }
  },
  computed: {
    resultJson() {
      return this.details.resultJson ? JSON.parse(this.details.resultJson) : null
    },
    innerVisible: {
      get() {
        return this.visible
      },
      set() {
        this.handleClose()
      }
    },
    orderNo() {
      return this.details.orderNo || ''
    }
  },
  methods: {
    async handleCreateOrder() {
      const resultJson = this.$refs.resultForm.resultJson
      const jobData = this.$refs.resultForm.job
      if (!resultJson || !jobData) {
        return
      }
      // 单票模式
      const job = await this.converJsonToJob()
      // 多单模式
      const newJobList = []
      const showGoods = this.$refs.resultForm.showGoods
      if (showGoods) {
        const goodList = resultJson.goodList
        if (goodList && goodList.length > 0) {
          for (const good of goodList) {
            const newJob = deepClone(job)
            // 件数
            const quantityContract = this.changeValue(good, 'numberOfPieces', ['CASE', 'PKGS', 'CTNS'])
            if (quantityContract !== 0) {
              newJob.quantityContract = Number(!StrUtils.isEmpty(good.packing) ? quantityContract.replace(job.packing, '') : quantityContract)
              newJob.quantityActual = newJob.quantityContract
            }
            // 毛重
            const weightContract = this.changeValue(good, 'grossWeight', ['KGS', this.$t('SeaExport.KG'), ','])
            newJob.weightContract = Number(weightContract)
            newJob.weightActual = newJob.weightContract
            // 体积
            const cubageContract = this.changeValue(good, 'volume', ['CBM', this.$t('SeaExport.CBM')])
            newJob.cubageContract = Number(cubageContract)
            newJob.cubageActual = newJob.cubageContract
            // 计费重量
            if (newJob.weightActual && newJob.cubageActual) {
              newJob.chargeWeight = this.handleChargeWeight(newJob.cubageActual, newJob.weightActual)
            }
            // 进仓编号
            newJob.warehouseNo = good.warehouseReceiptNo || ''
            // 客户参考号
            newJob.customerRefNo = good.ourCompanyNo || ''
            // 备注
            newJob.remarks = good.notes || ''
            newJobList.push(newJob)
          }
        }
        this.$logger.log('newJobList=========', newJobList)
      }
      this.$logger.log('job=========', job)
      if (this.source === SystemConstants.INTELLIGENT_DOCUMENT_SOURCE_REMOTE_SE.code) { // 远程订舱-海运
        job.lob = 'SE'
        this.$router.push({
          name: 'RemoteBooking',
          params: {
            view: 'detail',
            action: 'add',
            job,
            source: this.source
          }
        })
        return
      }
      if (newJobList.length > 0) { // 多单模式
        let i = 1
        for (const item of newJobList) {
          setTimeout(() => {
            this.$router.push({
              name: 'SeaBooking',
              query: { openNew: true, key: 'new Job' + i, action: 'add' },
              params: { job: item }
            })
            i++
          }, 100)
        }
      } else {
        this.$router.push({ name: 'SeaBooking', params: { job }})
      }
      this.$emit('close')
    },
    handleSave() {
      const loading = getLoading()
      const resultJson = this.$refs.resultForm.getSubmitData()
      const params = {
        uuid: this.details.uuid,
        resultJson: resultJson
      }
      this.$logger.log('======result=======', params)
      saveResultJsonXhq(params).then(res => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('success')
      }).finally(() => {
        loading.close()
      })
    },
    handleClose() {
      console.log('result close')
      this.$emit('close')
    },
    async converJsonToJob() {
      const job = this.$refs.resultForm.job
      const resultJson = this.$refs.resultForm.resultJson
      this.$logger.log('resultJson=========', resultJson)
      const newJob = job ? deepClone(job) : {}
      // 发货人
      this.scnChange(job, newJob, 'shipperLine', 'shipperLine')
      // 收货人
      this.scnChange(job, newJob, 'consigneeLine', 'consigneeLine')
      // 通知人
      this.scnChange(job, newJob, 'notifyPartyLine', 'notifyLine')
      // 起运港
      // 卸货港
      // 中转港
      // 交货地
      if (!job.destinationPortCode && job.dischargingPortCode) {
        newJob.destinationPortCode = job.dischargingPortCode
      }
      // 交货地区域
      if (newJob.destinationPortCode) {
        const port = getObjectByCache(basicCacheKeys.basic_data_Seaport, 'code', newJob.destinationPortCode)
        newJob.placeOfDeliveryRegion = port ? port.region : ''
      }

      newJob.etd = DateUtils.toDateStr(job.etd)
      newJob.sailingDay = DateUtils.getDateWeek(newJob.etd)
      // 船公司
      // 船名
      newJob.vessel = resultJson.vessel
      if (newJob.vessel && newJob.vessel.length > 64) {
        newJob.vessel = newJob.vessel.substr(0, 64)
      }
      newJob.voyageFlight = StrUtils.isEmpty(resultJson.voyageFlight) ? 'V.' + resultJson.voyage : resultJson.voyageFlight
      if (newJob.voyageFlight && newJob.voyageFlight.length > 255) {
        newJob.voyageFlight = newJob.voyageFlight.substr(0, 255)
      }
      // 品名
      newJob.cargoEnglishName = resultJson.goodName ? resultJson.goodName.toUpperCase() : ''
      // 唛头
      newJob.mark = resultJson.marks ? resultJson.marks.toUpperCase() : ''
      // 备注
      newJob.remarks = resultJson.remarks
      // 联系人
      newJob.customerContact = resultJson.contacts
      // 货物尺寸
      newJob.measurements = resultJson.goodSize
      newJob.fileSourceType = this.details['fileType']
      newJob.fileSourceName = this.details['fileName']
      newJob.filePreViewContent = this.details['filePreViewContent']
      newJob.fileSourceContent = this.details['fileSourceContent']
      // 运费条款
      // 运输条款job
      // 贸易条款
      // 包装
      // 整箱/拼箱  FCL/LCL
      // 提单形式 ORIGINAL 正本 1/SURRENDERED 电放 2/SEA WAYBILL 电放 3
      if (!StrUtils.isEmpty(job.orderType)) {
        newJob.seaCargoDoc = [{
          docType: 'HBL',
          releaseType: job.orderType
        }]
      }
      newJob.danUNNo = this.details.uuid
      newJob.signMBL = false
      newJob.signHBL = false
      newJob.virtualHBL = false
      newJob.vgm = false
      newJob.ams = false
      newJob.hds = false
      newJob.comercialInspectation = false
      newJob.heating = false
      newJob.itmService = false
      newJob.mblOnly = false
      newJob.transfering = false
      newJob.batch = false
      newJob.salePrice = false

      // 件数
      const quantityContract = this.changeValue(resultJson, 'numberOfPieces', ['CASE', 'PKGS', 'CTNS'])
      if (quantityContract !== 0) {
        newJob.quantityContract = Number(!StrUtils.isEmpty(job.packing) ? quantityContract.replace(job.packing, '') : quantityContract)
        newJob.quantityActual = newJob.quantityContract
      }
      // 毛重
      const weightContract = this.changeValue(resultJson, 'grossWeight', ['KGS', this.$t('SeaExport.KG'), ','])
      newJob.weightContract = Number(weightContract)
      newJob.weightActual = newJob.weightContract
      // 体积
      const cubageContract = this.changeValue(resultJson, 'volume', ['CBM', this.$t('SeaExport.CBM')])
      newJob.cubageContract = Number(cubageContract)
      newJob.cubageActual = newJob.cubageContract
      newJob.chargeWeight = Number(cubageContract)
      // 客户
      // 进仓编号
      newJob.warehouseNo = resultJson.warehouseReceiptNo || ''
      // 客户参考号
      newJob.customerRefNo = resultJson.ourCompanyNo || ''
      //
      if (job.arriveDate) {
        const warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
        warehouseInfo.arriveDate = job.arriveDate
        newJob.warehouseInfo = [warehouseInfo]
      }
      if (this.jingyuWarehouse && newJob.warehouseNo) {
        newJob.jobWarehouseNos = [{ warehouseNo: newJob.warehouseNo, quantity: '0' }]
      }
      // 带出联动信息
      await this.setOtherInfo(newJob, resultJson)
      return JSON.parse(JSON.stringify(newJob, (key, value) => {
        if (typeof value !== 'boolean') {
          if (!value || (Array.isArray(value) && !value.length || (typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length))) {
            return undefined
          }
        }
        return value
      }))
    },
    // 联动带出逻辑
    async setOtherInfo(newJob, resultJson) {
      // 揽货类型
      // 根据客户属性的揽货类型。单勾选自揽货=带出“自揽货“，  单勾选指定货=带出“指定货“。  同时勾选= 带出的是“自揽货”
      let customerDetail = ''
      if (!newJob.cargoSource && newJob.customerId && Number(newJob.customerId) > 0) {
        const customer = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', newJob.customerId)
        customerDetail = customer ? await Company.loadCustomer(customer.uuid).then(list => list.length > 0 ? list[0] : null) : ''
        let newCargoSource = ''
        if (customer && customerDetail) {
          if (customerDetail.designated && customerDetail.seftCanvass) {
            newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          } else if (customerDetail.designated && !customerDetail.seftCanvass) {
            newCargoSource = CargoSource.NC_CARGO_SOURCE.code
          } else if (!customerDetail.designated && customerDetail.seftCanvass) {
            newCargoSource = CargoSource.SC_CARGO_SOURCE.code
          }
        }
        newJob.cargoSource = newCargoSource
      }
      if (newJob.cargoSource) {
        // 根据“委托单位+卸货港+指定货”带出指定货代理
        if (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
          // 指定货代理
          if (customerDetail && newJob.dischargingPortCode) {
            const portDestinationAgents = await new Customer(customerDetail).getPortDestinationAgents()
            if (portDestinationAgents && portDestinationAgents.length > 0) {
              for (const agent of portDestinationAgents) {
                if (newJob.dischargingPortCode === agent.destinationPort) {
                  newJob.designationAgent = agent.destinationAgentId
                  break
                }
              }
            }
          }
        }

        // 分单运费条款
        if (!newJob.paymentTermHBL) {
          newJob.paymentTermHBL = (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) ? 'CC' : 'PP'
        }

        // 贸易条款
        if (!newJob.incoTerm) {
          newJob.incoTerm = (newJob.cargoSource === CargoSource.NC_CARGO_SOURCE.code) ? 'FOB' : 'CIF'
        }
      }

      // 计费重量
      if (resultJson.volume && resultJson.grossWeight) {
        newJob.chargeWeight = this.handleChargeWeight(resultJson.volume, resultJson.grossWeight)
      }
    },
    // 计算计费重量
    handleChargeWeight(cubage, weight) {
      if (!weight) {
        weight = 0
      }
      if (!cubage) {
        cubage = 0
      }
      if (isNaN(weight) || isNaN(cubage)) {
        return 0
      }
      weight = weight ? Number(weight) : 0
      cubage = cubage ? Number(cubage) : 0
      //
      weight = weight / 1000
      if (cubage > weight) {
        weight = cubage
      }
      if (weight > 0 && weight < 1) {
        weight = 1.00
      }
      return parseFloat(weight.toFixed(3))
    },
    scnChange(job, newJob, sourceField, targetField) {
      for (let i = 7; i >= 0; --i) {
        if (job[sourceField + i]) {
          newJob[targetField + i] = job[sourceField + i].toUpperCase()
        }
      }
    },
    toDateStr(dateStr) {
    },
    changeValue(job, targetField, replaceArr) {
      let result = 0
      if (!StrUtils.isEmpty(job[targetField])) {
        if (StrUtils.isEmpty(result)) {
          result = job[targetField]
          result = result ? result.trim() : ''
          for (const element of replaceArr) {
            result = result.replace(element, '')
          }
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss">
.intelligent-booking-result-dialog{
  min-width: 1200px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .el-dialog__body{
    padding: 0!important;
    display: flex;
    flex:1;
    overflow: hidden;
  }
}
</style>
